export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-17.jpg'),
        title: '物联网',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '信息技术革命新浪潮',
      description: `<p style="font-size: 1.8rem;">
      物联网，被视为继互联网之后的又一次信息技术革命浪潮。物联网所带来的产业价值将比互联网更加庞大，物联网将成为下一个万亿元级别的信息产业业务。
</p><p>
物联网已不是趋势，而是现实：互联网经过多年的发展，智能化应用设施的大量应用，已经普及到方方面面，为物联网的发展，飞跃前进，都打下了夯实的基础，在网络化、智能化的终端连接下，物联网已成为现实，正在逐步普及，未来趋势更是加强的表现。
我们的服务 <br/>
设计：我们拥有一支经验丰富的设计团队，可以根据客户对产品的要求，设计出让您满意的产品。我们能够提供从硬件选择到固件、操作系统、中间件和应用程序开发的全栈物联网技术解决方案。<br/>
开发：我们的团队可提供深厚的技术能力，对产品进行研发，提供360度QA测试，无缝自动化，硬件原型设计和一致性测试。通过专业化的研发，让我们的客户充满信心。<br/>
售后：作为一家提供全方位服务的技术提供商，我们以使客户始终处于业务前沿而自豪。我们帮助客户通过软件和硬件更新升级来解决产品更新迭代的问题，确保他们在竞争中保持领先地位。
</p>`
    },
    {
      title: '我们的优势',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-17.jpg')+`)"></span>
      <span class="list">
      <i></i>雄厚的技术研发团队<br/>
      <i></i>丰富的IT研发经验<br/>
      <i></i>有运营、追踪、分析海量数据并提供针对性解决方案的高效运作平台<br/>
      <i></i>出色的软件开发能力及一流的用户体验<br/>
      <i></i>熟悉各个行业运作的模式的管理团队<br/>
      <i></i>案例:<br/>
      <i></i>智慧生活<br/>
      <i></i>智慧城市<br/>
      <i></i>智慧制造

      </span>`
    }
  ]
}
